<template>
  <b-container class="contentcontainer site-detail__performance">
    <b-row class="contentcontainer__head">
      <b-col>
        <h2>{{$t('site.ttfb')}}</h2>
      </b-col>
    </b-row>
    <hr/>
    <b-row>
      <b-col>
        <TtfbSection />
      </b-col>
    </b-row>
  </b-container>
</template>

<script>

import TtfbSection from './TtfbSection'

export default {
  name: 'SiteDetailPerformance',
  components: {
    TtfbSection
  }
}

</script>
